// src/features/filter/filterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentDate: new Date().toLocaleDateString('en-CA', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }), // Apply client's system time zone
  tab: 1, // Default selected tab → "Active"
};
console.log(new Date().toLocaleDateString('en-CA', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }),'dateee')
const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setCurrentDate: (state, action) => {
      state.currentDate = action.payload;  // Update current date
    },
    setTab: (state, action) => {
      state.tab = action.payload;  // Update selected tab index
    },
  },
});

// Export actions
export const { setCurrentDate, setTab } = filterSlice.actions;

// Export the reducer
export default filterSlice.reducer;
